/**
 * CancelledStep - Trial cancelled confirmation
 *
 * Shows confirmation message after user cancels their trial.
 */

interface CancelledStepProps {
  onDismiss: () => void;
}

export function CancelledStep({ onDismiss }: CancelledStepProps) {
  return (
    <div className="flex flex-col items-center gap-6 py-4 text-center">
      {/* Header */}
      <div>
        <h2 className="text-2xl font-bold text-catch-dark-blue-90">
          Trial cancelled
        </h2>
        <p className="mt-3 text-catch-slate">
          You still have access for the remainder of your trial period. Feel
          free to explore - you can always rejoin later.
        </p>
      </div>

      {/* Continue CTA */}
      <button
        onClick={onDismiss}
        className="flex w-full items-center justify-center rounded-full bg-catch-avocado-400 px-5 py-4 text-sm font-bold text-catch-dark-blue-90 transition-opacity hover:opacity-90"
      >
        Continue
      </button>
    </div>
  );
}

export default CancelledStep;
